import { useEffect, useState } from 'react';

/**
 * Порог, после которого ожидание становится заметным.
 *
 * Возвращает false, пока ждём меньше `ms`. До порога экран не показывает ни
 * каркаса, ни спиннера: ответ локального сервера приходит за десятки
 * миллисекунд, и всякий индикатор, живущий такое время, читается как мигание,
 * а не как «идёт загрузка». Показываем ожидание только когда оно настоящее.
 */
export function useSlowWait(waiting, ms = 250) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!waiting) { setSlow(false); return undefined; }
    const t = setTimeout(() => setSlow(true), ms);
    return () => clearTimeout(t);
  }, [waiting, ms]);
  return slow;
}
